module.exports = __webpack_public_path__ + "static/media/AvenirBlack.72d53997.woff";